import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {Provider} from "react-redux";
import { HelmetProvider } from 'react-helmet-async';
// import { PersistGate } from 'redux-persist/integration/react';
import store from "./store/store";
import InvalidUrl from "./components/404/invalidUrl";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
    <HelmetProvider>
        <BrowserRouter>
            <Provider store={store}>
                <Routes>
                    <Route path="/presentation/:uuid/*" element={<App />} />

                    <Route path="*" element={<InvalidUrl />} />
                </Routes>
            </Provider>
        </BrowserRouter>
    </HelmetProvider>

);

